/**
 * @desc 编辑事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  data: defs.TheNewEventParameters,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/event/{id}/edit',
    data,
    params,
  });
}

export function mock(
  data: defs.TheNewEventParameters,
  params: Params,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/event/{id}/edit',
    data,
    params,
  });
}
